"use strict";
// Error code catalogue shared between upload clients (frontend) and the upload
// service (backend). The matching `FileUploadError` CLASS stays in backend
// because only backend throws — shipping a class to the browser bundle would
// inflate it for no benefit.
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadErrorCodes = void 0;
exports.FileUploadErrorCodes = {
    INVALID_MIME_TYPE: 'INVALID_MIME_TYPE',
    FILE_TOO_LARGE: 'FILE_TOO_LARGE',
    INVALID_FILENAME: 'INVALID_FILENAME',
    INVALID_PATH: 'INVALID_PATH',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    UNAUTHORIZED: 'UNAUTHORIZED',
    PROJECT_NOT_FOUND: 'PROJECT_NOT_FOUND',
    QUOTA_EXCEEDED: 'QUOTA_EXCEEDED',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    TOKEN_INVALID: 'TOKEN_INVALID',
    S3_ERROR: 'S3_ERROR',
    PROCESSING_ERROR: 'PROCESSING_ERROR',
    // A study's shared documents (#791): the commercial side adds while the study
    // is open and holds fewer than ten; a client never adds one.
    SHARED_DOCUMENTS_CLOSED: 'SHARED_DOCUMENTS_CLOSED',
    SHARED_DOCUMENTS_FULL: 'SHARED_DOCUMENTS_FULL',
    SHARED_DOCUMENT_FORBIDDEN: 'SHARED_DOCUMENT_FORBIDDEN',
};
//# sourceMappingURL=errors.js.map